<div class="col-md-10 offset-md-1" style="padding-top: 30px">
    <div class="input-group">
        <input class="form-control" placeholder="Type resource name or keyword" [(ngModel)]="searchTerms">
        <div class="pull-right">&nbsp;
            <button class="btn btn-primary btn-ncb-wide" [routerLink]="[0,'edit']">New Resource</button>
        </div>
    </div>
    <p>
    <div class="tableFixHead"> 
        <table>
            <thead>
                <th *ngFor="let col of cols"><a (click)="lh.setOrder(col.name);">
                    <span><i *ngIf="lh.listOrder==col.name" [className]="lh.orderDesc?'fa fa-sort-alpha-desc':'fa fa-sort-alpha-asc'"></i></span>
                    {{col.label}}</a>&nbsp;</th>
            </thead>
            <tbody *ngFor="let resource of resources">
                <tr *ngIf="filterResults(resource)">
                    <td width=80%><a [routerLink]="['/resource',resource.id,'edit']" [innerHTML]="resource.title | highlight: this.searchTerms"></a></td>
                    <td>{{resource.updateddate | date: 'MM/dd/yy h:mm a'}}</td>
                    <td>{{resource.updatedby}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div> 